import { CommonInputControlDirective } from '../../directives/control/common-input-control.directive';
import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImgComponent } from '../../kh-img/img.component';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'kh-common-input',
  standalone: true,
  imports: [CommonModule, FormsModule, ImgComponent, NgxMaskDirective],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommonInputComponent),
      multi: true
    }
  ],
  templateUrl: './common-input.component.html',
  styleUrls: ['./common-input.component.less']
})
export class CommonInputComponent extends CommonInputControlDirective {}
